const values = [
  { num: "01", title: "Clarity Over Guesswork", desc: "Businesses should operate with clarity, not guesswork." },
  { num: "02", title: "Simplicity Over Complexity", desc: "Systems should simplify operations, not complicate them." },
  { num: "03", title: "Connected Over Fragmented", desc: "Data should be connected, not fragmented." },
  { num: "04", title: "Accountability by Design", desc: "Accountability should be built into workflows." },
  { num: "05", title: "Growth Through Technology", desc: "Technology should support growth, not slow it down." },
];

export default function ValuesSection() {
  return (
    <section className="py-16 md:py-24 bg-graphite-900">
      <div className="w-full px-4 sm:px-6 lg:px-8 xl:px-16">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-graphite-700 bg-graphite-800/50 mb-6">
              <span className="text-xs font-medium text-silver-300 tracking-wide">What We Believe</span>
            </div>
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-4">What We Believe</h2>
            <p className="text-base md:text-lg text-silver-300 max-w-2xl mx-auto leading-relaxed">
              These principles guide how we design, build, and deliver every StackMap solution.
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {values.map((v) => (
              <div key={v.num} className="glass-card p-6 md:p-7 flex flex-col gap-4 group">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-emerald-accent/10 group-hover:bg-emerald-accent/20 transition-colors duration-300">
                  <span className="text-sm font-bold text-emerald-accent">{v.num}</span>
                </div>
                <h3 className="text-base md:text-lg font-bold text-white group-hover:text-emerald-soft transition-colors duration-300">{v.title}</h3>
                <p className="text-sm text-silver-400 leading-relaxed">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
